import { Line, ReelWinPosition } from '@cgs/data-access';
import { Container, Platform, SequenceAction, T_Platform } from '@cgs/wge';

import { SLOT_GAME_SETTINGS_TOKEN, SlotGameSettings } from '../../../../new/slot-game-settings';
import { SpinConfig } from '../../../../reels_engine/game_config/game_config';
import { ReelsSoundModel } from '../../../../reels_engine/reels_sound_model';
import { RESOURCES_COMPONENT_TOKEN } from '../../../../type_definitions';
import { ResourcesComponent } from '../../resources_component';
import {
  ExpandedShortWinlinesAction,
  ExpandedShortWinlinesActionParams,
} from '../complex_win_line_actions/expanded_short_winlines_action';
import { ExpandedWinlinesActions } from '../complex_win_line_actions/expanded_winlines_action';
import { SpecialNWaysAction } from '../complex_win_line_actions/special_nways_action';
import { ILineOptions, WinlineLineDrawer } from '../complex_win_line_actions/winline_line_drawer';
import { WinLineActionComponent } from './win_line_action_component';

export class ExpandedWinLineActionComponent extends WinLineActionComponent {
  protected readonly _lineDrawer: WinlineLineDrawer | null;

  constructor(
    container: Container,
    {
      repeatWinLineSound = true,
      winlineHolderId = undefined,
      lineOptions = undefined,
    }: {
      repeatWinLineSound?: boolean;
      lineOptions?: ILineOptions;
      winlineHolderId?: string;
    } = {}
  ) {
    super(container, repeatWinLineSound);

    const platform = this.container.resolve<Platform>(T_Platform);
    const paylines = this.container
      .resolve<SlotGameSettings>(SLOT_GAME_SETTINGS_TOKEN)
      .getPaylines();

    if (lineOptions && winlineHolderId) {
      this._lineDrawer = new WinlineLineDrawer(
        lineOptions,
        platform.videoSystem.renderDevice!,
        paylines
      );
      const holder = container
        .resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN)
        .slot.findById(winlineHolderId);
      holder?.addChild(this._lineDrawer);
    }
  }

  public update(
    reelsSoundModel: ReelsSoundModel,
    winLines: Line[],
    viewReels: number[][],
    spinConfig: SpinConfig,
    winPositions: ReelWinPosition[]
  ): void {
    // super.update(reelsSoundModel, winLines, viewReels, spinConfig, winPositions);

    const lineOption: ExpandedShortWinlinesActionParams = {
      container: this.container,
      lineDrawer: this._lineDrawer,
      spinConfig: spinConfig,
      winLines,
      winPositions: winPositions,
    };

    const shortWinLineAction = new SequenceAction([new ExpandedShortWinlinesAction(lineOption)]);

    const winLineAction = new ExpandedWinlinesActions(lineOption, this.repeatWinLineSound);

    const specialLineAction = new SpecialNWaysAction(
      this.container,
      winLines,
      spinConfig,
      winPositions
    );

    this.winLineAction = new SequenceAction([shortWinLineAction, winLineAction]);
    this.shortWinLineAction = shortWinLineAction;
    this.specialLineAction = specialLineAction;

    this.enableFade(winLines, winPositions);
  }
}
